import type { DenominatorType } from '@coorum-research/shared-common/types/tag-statistics-configuration.type'
import { clsx } from 'clsx/lite'
import { type HTMLAttributes, type ReactNode, useContext } from 'react'
import { ThemeContext } from './ThemeContext'

type RootProps = {
  className?: string
  children: ReactNode
}

export function StatCardsRoot({ className, children }: RootProps) {
  return (
    <div className={clsx('grid grid-cols-2 gap-2', className)}>
      {children}
    </div>
  )
}

type ItemProps = HTMLAttributes<HTMLDivElement> & {
  label: string
  prefix?: string
  suffix?: string
  children: ReactNode
  enableRankDisplay?: boolean
  denominatorType?: DenominatorType
  denominatorNumber?: number
  numeratorNumber?: number
}

export function StatCardsItem({
  label,
  prefix,
  suffix,
  className,
  children,
  enableRankDisplay,
  numeratorNumber,
  denominatorNumber,
}: ItemProps) {
  const { mainColor, mainTextColor } = useContext(ThemeContext)

  let isDisplayRank = false
  if (enableRankDisplay && numeratorNumber && (numeratorNumber > 0) && denominatorNumber && (denominatorNumber > 0)) {
    isDisplayRank = true
  }

  return (
    <div className={clsx('flex h-[88px] w-full flex-col items-center justify-center rounded-2xl bg-white p-2.5', className)}>
      <div
        className="break-all text-center text-xs"
        style={{ color: mainTextColor }}
      >
        {label}
      </div>
      <div
        className="align-baseline"
        style={{ color: mainColor }}
      >
        {prefix && (
          <span className="text-sm">
            {prefix}
          </span>
        )}
        <span className="text-4xl">
          {children}
        </span>
        {suffix && (
          <span className="ml-0.5 text-sm">
            {suffix}
          </span>
        )}
      </div>
      {isDisplayRank && (
        <div className="flex text-xs">
          {numeratorNumber?.toLocaleString()}&nbsp;/&nbsp;{denominatorNumber?.toLocaleString() || '?'}&nbsp;位
        </div>
      )}
    </div>
  )
}
